import { MibpLogger } from './../../../../../../services/logservice/mibplogger.class';
import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { BroadcastService, GlobalConfigService } from 'root/services';
import { firstValueFrom, Subscription } from 'rxjs';
import { BasicChartData } from "root/components/chart";
import { LogService } from './../../../../../../services/logservice/log.service';

import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';
import { MibpChartPieComponent } from 'root/components/chart/mibp-chart-pie/mibp-chart-pie.component';
import { MibpNewPopoverComponent } from 'root/shared/components/popovers/new-popover/new-popover.component';
import { businessRelationsFnGetCreditLimitCount } from "root/mibp-openapi-gen/fn/business-relations/business-relations-fn-get-credit-limit-count";
import { MibpApiService } from "root/mibp-openapi-gen/mibp-api.service";

@Component({
  selector: 'mibp-dashboard-creditlimit',
  templateUrl: './dashboard-creditlimit.component.html',
  styleUrls: ['./dashboard-creditlimit.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ResourceStringComponent, MibpChartPieComponent, MibpNewPopoverComponent]
})
export class MibpDashboardCreditLimitComponent implements OnInit, OnDestroy {
  private mibpApiService = inject(MibpApiService);
  private broadcast = inject(BroadcastService);
  private globalConfig = inject(GlobalConfigService);
  isLoading = true;
  hasError = false;
  creditLimitSub: Subscription;
  creditLimitChartData =null;
  CreditUsedCount = 0;
  CreditRemainingCount = 0;
  color=null;
  isDelSeq = true;
  isDynamicdashboard = false;
  log: MibpLogger;

  constructor() {
    const logger = inject(LogService);

    this.log = logger.withPrefix(`dashboard-creditlimit.component`);
  }




  update(): void {
    this.hasError = false;
    this.isLoading = true;
    this.creditLimitChartData = null;
    this.CreditUsedCount = 0;
    this.CreditRemainingCount = 0;
    firstValueFrom(this.mibpApiService.invoke(businessRelationsFnGetCreditLimitCount)).then(creditLimitCount => {

      if(creditLimitCount.creditRemainingCount < 0){

        this.CreditRemainingCount = null;
        this.creditLimitChartData = null;
        this.CreditUsedCount= null;
        this.isLoading = false;
      }
      else{
        if (creditLimitCount.creditUsedCount >= 0 && creditLimitCount.creditUsedCount <= 50 ) {
          this.color =[
            '#DCDCDC','#00CC00'
          ];
          this.CreditUsedCount = creditLimitCount.creditUsedCount;
          this.CreditRemainingCount = creditLimitCount.creditRemainingCount;
          this.creditLimitChartData = [

            {
              labelResourceString: 'Credit_Used',
              value: creditLimitCount.creditUsedCount,

            },
            {
              labelResourceString: 'Credit_Remaining',
              value: creditLimitCount.creditRemainingCount
            }
          ] as BasicChartData[];


        }
        else if(creditLimitCount.creditUsedCount > 50 && creditLimitCount.creditUsedCount <= 75 )
        {
          this.color =[
            '#FF6600', '#00CC00'
          ];
          this.CreditUsedCount = creditLimitCount.creditUsedCount;
          this.CreditRemainingCount = creditLimitCount.creditRemainingCount;
          this.creditLimitChartData = [

            {
              labelResourceString: 'Credit_Used',
              value: creditLimitCount.creditUsedCount
            },
            {
              labelResourceString: 'Credit_Remaining',
              value: creditLimitCount.creditRemainingCount
            }
          ] as BasicChartData[];
        }
        else if(creditLimitCount.creditUsedCount > 75 && creditLimitCount.creditUsedCount <= 100 )
        {
          this.color =[
            '#F00000', '#00CC00'
          ];
          this.CreditUsedCount = creditLimitCount.creditUsedCount;
          this.CreditRemainingCount = creditLimitCount.creditRemainingCount;
          this.creditLimitChartData = [

            {
              labelResourceString: 'Credit_Used',
              value: creditLimitCount.creditUsedCount
            },
            {
              labelResourceString: 'Credit_Remaining',
              value: creditLimitCount.creditRemainingCount
            }
          ] as BasicChartData[];
        }
      }

      this.isLoading = false;

    }).catch(
      error => {
        this.log.error('error getting credit limit count',error);
        this.hasError = true;
      });
  }




  ngOnInit(): void {
    this.creditLimitSub = this.broadcast.deliverySequence.subscribe(x=>{
      if(x){
        this.update();
        this.isDelSeq = true;
      }
      else{
        this.isDelSeq = false;
      }
    });
    this.isDynamicdashboard = this.globalConfig.activateDynamicDashboard;
  }


  ngOnDestroy(): void {
    this.creditLimitSub?.unsubscribe();
  }

}
